import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=1724c00a&"
import script from "./BaseWidget.vue?vue&type=script&lang=ts&"
export * from "./BaseWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports